import React, { PropsWithChildren } from 'react'

import { LoaderOverlayWrapperDS } from '@src/components/blocks/loader-overlay-wrapper-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { LoaderOverlayWrapperLegacy } from './loader-overlay-wrapper-legacy'

interface ILoaderOverlayWrapper {
  isLoading: boolean
  overlayClasses?: string
}

export const LoaderOverlayWrapper: React.FC<PropsWithChildren<ILoaderOverlayWrapper>> = props => {
  if (shouldUseDesignSystem()) {
    return <LoaderOverlayWrapperDS {...props} />
  }

  return <LoaderOverlayWrapperLegacy {...props} />
}
